const COLORS = {
  primary: '#15cdfc',
  secondarySection: '#fff'
}

export default COLORS
